import React from "react";
import WebDevelopment from "../components/WebDevelopment/WebDevelopment";

export default function WebDevelopmentPage(){
    return (
        <main>
          <WebDevelopment/>
        </main>
      );
    }
